import React from "react";
import { useNavigate } from "react-router-dom";

export default function Start() {
  const navigate = useNavigate();

  //navigate to /account/work
  navigate("/account/work");

  //navigate to /account

  const sections = [
    {
      id: 1,
      title: "Work",
      path: "/account/work",
      icon: "bi-briefcase-fill",
      color: "primary",
      description: "Manage your work tasks and projects",
    },
    {
      id: 2,
      title: "Finance",
      path: "/account/finance",
      icon: "bi-cash-coin",
      color: "success",
      description: "Track your finances and expenses",
    },
    {
      id: 3,
      title: "Calendar",
      path: "/account/calendar",
      icon: "bi-calendar-event-fill",
      color: "info",
      description: "View and manage your schedule",
    },
    {
      id: 4,
      title: "Sport",
      path: "/account/sport",
      icon: "bi-trophy-fill",
      color: "warning",
      description: "Track your fitness and activities",
    },
  ];

  return (
    <div className="container-fluid py-5">
      <div className="row mb-4">
        <div className="col-12">
          <h1 className="mb-2">Welcome Back!</h1>
          <p className="text-muted">Choose a section to get started</p>
        </div>
      </div>

      <div className="row g-4">
        {sections.map((section) => (
          <div key={section.id} className="col-12 col-md-6 col-lg-3">
            <div
              className={`card h-100 border-${section.color} shadow-sm cursor-pointer hover-elevate-up`}
              onClick={() => navigate(section.path)}
              style={{ cursor: "pointer", transition: "all 0.3s ease" }}
            >
              <div className="card-body text-center p-5">
                <div className={`mb-4`}>
                  <i
                    className={`bi ${section.icon} text-${section.color}`}
                    style={{ fontSize: "3rem" }}
                  ></i>
                </div>
                <h3 className="card-title mb-3">{section.title}</h3>
                <p className="card-text text-muted">{section.description}</p>
              </div>
              <div
                className={`card-footer bg-${section.color} bg-opacity-10 border-0`}
              >
                <div className="text-center">
                  <span className={`text-${section.color} fw-bold`}>
                    Open <i className="fas fa-arrow-right"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
